import { Grid } from '@chakra-ui/core'
import { StorefrontPlugins } from '@engyalo/storefront-types'
import { SoupProductItem } from './plugins/soupProduct'

export const plugins = {
   CollectionProduct: {
       container: SoupProductItem,
   },
  
  Catalogue: {
    container: Grid,
    props: {
      gridTemplateColumns: '1fr',
      backgroundColor:"primary.900",
    }
  }
} as StorefrontPlugins
